module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ok),
      expression: "ok"
    }],
    staticClass: "sider-bar"
  }, [_c('ul', {
    on: {
      "click": _vm.closeNav
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/user/login"
    }
  }, [_c('i', {
    staticClass: "icon-login"
  }), _vm._v("登录")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/todoList/all"
    }
  }, [_c('i', {
    staticClass: "icon-calendar-empty"
  }), _vm._v("全部事项")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/todoList/completed"
    }
  }, [_c('i', {
    staticClass: "icon-calendar-check-o"
  }), _vm._v("完成事项")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/todoList/active"
    }
  }, [_c('i', {
    staticClass: "icon-calendar-times-o"
  }), _vm._v("在忙事项")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/user/cloud"
    }
  }, [_c('i', {
    staticClass: "icon-upload-cloud",
    staticStyle: {
      "margin-left": "-2px"
    }
  }), _vm._v("云备份")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/user/about"
    }
  }, [_c('i', {
    staticClass: "icon-info"
  }), _vm._v("关于")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28fe3a04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation.vue
// module id = 33
// module chunks = 0